import $ from 'cash-dom';
import ObjectHelper from '../../../components/ObjectHelper';

/**
 * Class PgFilterPopupProxy It's Proxy class for PgFilter.
 */
class PgFilterPopupProxy {
	constructor() {
		this._defaultFilters = null;

		this._$filterButton = null;
		this._$sortButton = null;
		this._$resultsFilter = null;
		this._$resultsSorter = null;
		this._$clearBtn = null;
		this._$doneBtn = null;
	}

	/**
	 * @param {[{}]} defaultFilters
	 * @return {PgFilterPopupProxy}
	 */
	setDefaultFilters(defaultFilters) {
		this._defaultFilters = defaultFilters;

		return this;
	}

	init() {
		this._queryElements();
		this._applyDefaultFilters();
		this._offHandlers();

		this._$filterButton.on('click', (e) => {
			e.preventDefault();
			this._showFilters();
		});
		this._$resultsFilter.find('.close-btn').on('click', (e) => {
			e.preventDefault();
			this._hideFilters();
		});
		this._$resultsFilter.find('input[type=checkbox]').on('click', (e) => {
			this._handleFilterCheckboxChange($(e.target));
		})

		this._$sortButton.on('click', (e) => {
			e.preventDefault();
			this._showSortes();
		});
		this._$resultsSorter.find('.close-btn').on('click', (e) => {
			e.preventDefault();
			this._hideSorters();
		});
		this._$resultsSorter.find('input[type=checkbox]').on('click', (e) => {
			this._handleSortCheckboxChange($(e.target));
		});

		this._$clearBtn.on('click', (e) => {
			e.preventDefault();

			this._cleanFilters();
			$(document).trigger('pg-clear-filters');
			this._hideFilters();
		});

		this._$doneBtn.on('click', (e) => {
			e.preventDefault();

			const filters = this._getSelectedFilters();
			$(document).trigger('pg-set-filters', {filters});
			this._hideFilters();
		});
	}

	_queryElements() {
		const $filterAndSortHolder = $('.mobile-sort-and-filter');

		this._$filterButton = $filterAndSortHolder.find('.filter');
		this._$sortButton = $filterAndSortHolder.find('.sort');

		this._$resultsFilter = $('.results-filter.filter');
		this._$resultsSorter = $('.results-filter.sort');

		this._$clearBtn = this._$resultsFilter.find('.clear-filters-btn');
		this._$doneBtn = this._$resultsFilter.find('.done-btn');
	}

	_applyDefaultFilters() {
		if (!this._defaultFilters) {
			return;
		}

		for (const [filterName, filterValues] of Object.entries(this._defaultFilters)) {
			for (const filterValue of filterValues) {
				this._$resultsFilter
					.find(`input[type=checkbox][data-name="${filterName}"][data-value="${filterValue}"]`)
					.prop('checked', true);
			}
		}
	}

	_offHandlers() {
		this._$filterButton.off('click');
		this._$sortButton.off('click');

		this._$resultsFilter.find('.close-btn').off('click');
		this._$resultsFilter.find('input[type=checkbox]').off('click');

		this._$resultsSorter.find('.close-btn').off('click');
		this._$resultsSorter.find('input[type=checkbox]').off('click');

		this._$clearBtn.off('click');
		this._$doneBtn.off('click');
	}

	_showFilters() {
		this._$resultsFilter.removeClass('hidden');
	}

	_hideFilters() {
		this._$resultsFilter.addClass('hidden');
	}

	_showSortes() {
		this._$resultsSorter.removeClass('hidden');
	}

	_hideSorters() {
		this._$resultsSorter.addClass('hidden');
	}

	_handleFilterCheckboxChange($currentCheckbox) {
		if (!$currentCheckbox.data('value')) {
			this._uncheckAllExceptAny($currentCheckbox);
		} else {
			this._uncheckAny($currentCheckbox)
		}
	}

	_uncheckAllExceptAny($currentCheckbox) {
		$currentCheckbox.closest('.checkbox-group').find('input[type=checkbox]').each((i, checkbox) => {
			const $checkbox = $(checkbox);

			if ($checkbox.data('value')) {
				$checkbox.prop('checked', false);
			}
		});
	}

	_uncheckAny($currentCheckbox) {
		$currentCheckbox.closest('.checkbox-group').find('input[type=checkbox][data-value=""]').prop('checked', false);
	}

	_handleSortCheckboxChange($currentCheckbox) {
		$currentCheckbox.closest('.checkbox-group').find('input[type=checkbox]').each((i, checkbox) => {
			const $checkbox = $(checkbox);

			if ($currentCheckbox.attr('name') !== $checkbox.attr('name')) {
				$checkbox.prop('checked', false);
			}
		});

		$(document).trigger('pg-sort', {sortBy: $currentCheckbox.attr('name')});
		this._hideSorters();
	}

	_cleanFilters() {
		this._$resultsFilter.find('input[type=checkbox]').each((i, checkbox) => {
			const $checkbox = $(checkbox);

			if ($checkbox.data('value')) {
				$checkbox.prop('checked', false);
			} else {
				$checkbox.prop('checked', true);
			}
		});
	}

	_getSelectedFilters() {
		const selectedFilters = {};

		this._$resultsFilter.find('input[type=checkbox]:checked').each((i, checkbox) => {
			const $checkbox = $(checkbox);
			ObjectHelper.addAsArrayElement(selectedFilters, $checkbox.data('name'), $checkbox.data('value'));
		});

		return selectedFilters;
	}
}

const pgFilterPopupProxy = new PgFilterPopupProxy();
export default pgFilterPopupProxy;
